export default __webpack_public_path__ + "static/media/salacity.0daec179.txt";